import { useState } from "react";
import { Card } from "@/components/Shared/Card";
import { Content } from "@/components/ui/ContentArea";
import { DateRangePicker } from "@/components/ui/Calendar/datepicker";
import { useApi } from "@/hooks/useApi";
import { useAuth } from "@/hooks/useAuth";
import { GrafanaPanel } from "@/components/Dashboad/GrafanaPanel";
import {
	ConfigP1,
	ConfigP2,
	ConfigP3,
} from "@/components/Dashboad/Config/GrafanaConfig";

export function DashboardPage() {
	const [selectedRange, setSelectedRange] = useState<{
		from: Temporal.PlainDate | undefined;
		to: Temporal.PlainDate | undefined;
	}>({
		from: Temporal.Now.plainDateISO().subtract({ years: 1 }),
		to: Temporal.Now.plainDateISO(),
	});

	const api = useApi();
	const auth = useAuth();
	const queryToken = api.useQuery(
		"get",
		"/v1/Empresa/Dashboard/TokenGrafana",
		{},
	);

	const companyId =
		auth.user?.userId && import.meta.env.VITE_BI_MODE != "debug"
			? auth.user.userId
			: 1;

	// Al entrar en la página se inicia sesión con un token muy corto
	// useEffect(() => {
	// 	if (queryToken.data) {
	// 		const loginUrl = `https://aeiriojabi.iker.wunder.intranet/login/jwt?token=${queryToken.data.token}`;
	// 		// Creamos un iframe invisible para hacer el login automático
	// 		const iframe = document.createElement("iframe");
	// 		iframe.src = loginUrl;
	// 		iframe.style.display = "none";
	// 		iframe.onload = () => {
	// 			setIsLoggedIn(true);
	// 			iframe.remove();
	// 		};
	// 		document.body.appendChild(iframe);
	// 	}
	// }, [queryToken.data !== undefined]);

	return (
		<Content className="p-5">
			<Card>
				<div className="dashboardNav">
					<img src="/img/Logo_Cluster.svg" />
					<DateRangePicker
						value={selectedRange}
						onChange={setSelectedRange}
						literal="Periodo"
					/>
					<select className="dashBoardSelector" onChange={(e) => { }}>
						<option>Diario</option>
						<option selected>Mensual</option>
						<option>Anual</option>
					</select>
				</div>
			</Card>
			<br />

			<br />
			{queryToken.data == null ? (
				<div>Cargando...</div>
			) : (
				<>
					<div className="grafanaContainer">
						{ConfigP1.map((grafanaConf) => (
							<GrafanaPanel
								panelNumber={grafanaConf.panelNumber}
								height={grafanaConf.height}
								key={grafanaConf.panelNumber}
								companyId={companyId}
								selectedRange={selectedRange}
								queryToken={queryToken.data.token}
							/>
						))}
					</div>
					<div style={{ display: "flex" }}>
						<div className="grafanaContainer">
							{ConfigP2.map((grafanaConf) => (
								<GrafanaPanel
									panelNumber={grafanaConf.panelNumber}
									height={grafanaConf.height}
									key={grafanaConf.panelNumber}
									companyId={companyId}
									selectedRange={selectedRange}
									queryToken={queryToken.data.token}
								/>
							))}
						</div>
						<div className="grafanaContainer">
							{ConfigP3.map((grafanaConf) => (
								<GrafanaPanel
									panelNumber={grafanaConf.panelNumber}
									height={grafanaConf.height}
									key={grafanaConf.panelNumber}
									companyId={companyId}
									selectedRange={selectedRange}
									queryToken={queryToken.data.token}
								/>
							))}
						</div>
					</div>
				</>
			)}
		</Content>
	);
}
